import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Sizes from 'UI/sizes';

export default class Initials extends React.Component
{
    static propTypes = {
        initials: PropTypes.string,
        size: PropTypes.string
    };

    render()
    {
        const classes = classNames({
            [this.props.className]: true,
            "inline-flex items-center justify-center bg-gray-500": true,
        });

        const textClasses = classNames({
            "font-medium leading-none text-white": true,
            "text-xs": this.props.size === Sizes.EXTRA_SMALL,
            "text-sm": this.props.size === Sizes.SMALL,
            "text-base": this.props.size === Sizes.MEDIUM,
            "text-lg": this.props.size === Sizes.LARGE,
            "text-xl": this.props.size === Sizes.EXTRA_LARGE,
        });

        return <span className={classes}>
            <span className={textClasses}>{this.props.initials}</span>
        </span>;
    }
}
